module.exports = __webpack_public_path__ + "media/images/gift/gift-step2-8c7b33230f9c5dc969d794c71388577f.png";